// Copyright (c) 2016 Deere & Company

import CustomerFailed, {getDefaultState} from '../state/customer-failed';
import actions from '../../product/actions-list';

const ckcCustomerFailure = (state, action) =>
CustomerFailed.update(state, {
    ckcCustomerFailed: {
        $set: action.ckcCustomerFailed
    }
});

const resetCkcCustomerFailure = () => getDefaultState();

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.UPDATE_CKC_CUSTOMER_FAILURE]: ckcCustomerFailure,
        [actions.RESET_CKC_CUSTOMER_FAILURE]: resetCkcCustomerFailure
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/shared/reducers/customer-failed.js